import type { ButtonProps } from "./Button.types";
import { getButtonStyles } from "./Button.styles";
import { Icon } from "../../atoms/Icon";
import { cn } from "@/utils/cn";

export const Button = ({
  children,
  icon,
  iconSide = "left",
  variant,
  color = "primary",
  size = "default",
  iconOnly = false,
  disabled = false,
  onClick,
  className,
  ...props
}: ButtonProps) => {
  const styles = getButtonStyles({
    variant,
    iconOnly,
    iconSide,
    disabled,
    size,
  });

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(styles.button, className)}
      {...props}
    >
      {icon && <Icon name={icon} />}

      {!iconOnly && children && <div className="text-nowrap">{children}</div>}

      {iconOnly && !icon && children && <div className="text-nowrap">{children}</div>}
    </button>
  );
};
